import React from "react";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import ProductOverview from "./product-overview";

const BessDetails = ({ bess }) => {
  let publicUrl = process.env.PUBLIC_URL + "/";

  const handleDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUserManualDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="ltn__shop-details-area pb-10">
      <div className="container">
        <ProductOverview overview={bess?.productOverview} />
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
              <div className="ltn__blog-meta mt-2">
                <ul>
                  <li style={{ marginBottom: "6px" }}>
                    <button
                      onClick={() => handleDownload("bess-105kwh-brochure.pdf")}
                      className="btn btn-success d-flex align-items-center"
                      style={{
                        gap: "10px",
                        fontWeight: "light",
                        padding: "10px 15px",
                        backgroundColor: "red",
                        border: "none",
                      }}
                    >
                      Download Brochure
                      <i
                        className="fas fa-download"
                        style={{ color: "white" }}
                      ></i>
                    </button>
                  </li>
                  {/* <li>
                    <button
                      onClick={() =>
                        handleUserManualDownload("Battery-User-Manual.pdf")
                      }
                      className="btn btn-success d-flex align-items-center"
                      style={{
                        gap: "10px",
                        fontWeight: "light",
                        padding: "10px 15px",
                        backgroundColor: "red",
                        border: "none",
                      }}
                    >
                      Download User Manual
                      <i
                        className="fas fa-download"
                        style={{ color: "white" }}
                      ></i>
                    </button>
                  </li> */}
                </ul>
              </div>

              <h1>{bess?.name}</h1>
              <h4>{bess?.subtitle}</h4>
              {Array.isArray(bess.description) ? (
                <>
                  {bess.description.map((section, idx) => (
                    <div key={idx}>
                      {section.title && <h5>{section.title}</h5>}
                      <p>{section.text}</p>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <h4>Description</h4>
                  <p>{bess.description}</p>
                </>
              )}

              <h4>System Configuration & Flexibility</h4>
              <div className="property-detail-info-list section-bg-1 clearfix mb-30">
                <ul>
                  {Object.entries(bess.systemConfig).map(([key, value]) => (
                    <li key={key}>
                      <label>{key}:</label> <span>{value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <h4>Technical Specifications</h4>
              <Accordion defaultActiveKey="0">
                {Object.entries(bess.specifications).map(
                  ([category, details], index) => (
                    <Accordion.Item eventKey={index.toString()} key={category}>
                      <Accordion.Header>{category}</Accordion.Header>
                      <Accordion.Body>
                        <ul className="list-group list-group-flush">
                          {Object.entries(details).map(([key, value]) => (
                            <li
                              key={key}
                              className="list-group-item d-flex justify-content-between"
                            >
                              <span className="fw-bold">{key}:</span>{" "}
                              <span>{value}</span>
                            </li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  )
                )}
              </Accordion>

              <h4>From Our Gallery</h4>
              <div className="ltn__property-details-gallery mb-30">
                <div className="row">
                  <div className="col-md-6">
                    {bess?.gallery?.[0] && (
                      <img
                        className="mb-30"
                        src={publicUrl + bess.gallery[0].src}
                        alt={bess.gallery[0].alt}
                      />
                    )}
                    {bess?.gallery?.[1] && (
                      <img
                        className="mb-30"
                        src={publicUrl + bess.gallery[1].src}
                        alt={bess.gallery[1].alt}
                      />
                    )}
                  </div>
                  <div className="col-md-6">
                    {bess?.gallery?.[2] && (
                      <img
                        className="mb-30"
                        src={publicUrl + bess.gallery[2].src}
                        alt={bess.gallery[2].alt}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-12">
            <aside className="sidebar ltn__shop-sidebar ltn__right-sidebar---">
              <div className="widget ltn__popular-product-widget">
                <h4 className="ltn__widget-title ltn__widget-title-border-2">
                  Atom Power Battery Dashboard
                </h4>
                <div className="row ltn__popular-product-widget-active slick-arrow-1">
                  <div className="col-12">
                    <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                      <div className="product-img go-top">
                        <a
                          href="https://dashboard.atom-power.com/login/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={
                              publicUrl + "assets/img/product-3/atom.webp"
                            }
                            alt="Atom Power Battery Dashboard"
                          />
                        </a>
                      </div>
                      <div className="product-info">
                        <p>
                          Effortlessly track your Atom Power Battery health
                          and status in real time through our proprietary
                          Smart Dashboard. Gain Real-Time Battery Insights,
                          Anytime, Anywhere, ensuring continuous optimization
                          and ultimate power reliability.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BessDetails;
